import { configureStore } from "@reduxjs/toolkit";

// import {createStore, combineReducers} from 'redux';
import labelReducer from './reducers/labelsReducer';
import localizationReducer from './reducers/localizationReducer';

export default configureStore({
  reducer: {
    labelsData: labelReducer,
    i18n: localizationReducer
  },
  middleware: getDefaultMiddleware =>
  getDefaultMiddleware({
    serializableCheck: false,
  })
});


